module.exports = __webpack_public_path__ + "static/media/pr-fr-img.3d723851.png";